// 防抖
function _debounce (fn, wait) {
  let timout = null
  return function () {
    let context = this
    let args = arguments
    if (timout)clearTimeout(timout)
    timout = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}
const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
const formatTimeFmt = (fmt, date) => {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    };
  };
  return fmt;
}
/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 *
 * @param num1加数1
 * @param num2加数2
 */
 const numAdd = (num1, num2) => {
  var baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}

/**
 * 减法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * @param num1被减数
 * @param num2减数
 */
const numSub = (num1, num2) => {
  var baseNum, baseNum1, baseNum2;
  var precision; // 精度
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
}

/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 *
 * @param num1被乘数
 * @param num2乘数
 */
const numMulti = (num1, num2) => {
  var baseNum = 0;
  try {
    baseNum += num1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    baseNum += num2.toString().split('.')[1].length;
  } catch (e) {}
  return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum);
}

/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 *
 * @param num1被除数
 * @param num2除数
 */
const numDiv = (num1, num2) => {
  let baseNum1 = 0
  let baseNum2 = 0;
  var baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum3 = Number(num1.toString().replace('.', ''));
  baseNum4 = Number(num2.toString().replace('.', ''));
  return numMulti((baseNum3 / baseNum4), Math.pow(10, baseNum2 - baseNum1));
}

const regExp = {
  // 是否是正数
  isPositiveNumber: (str) => {
    const reg = /^\d+(\.\d{1,2})?$/
    return reg.test(str)
  },
  // 只允许数字
  isNum: (str) => {
    const reg = /^(-|\+)?\d+$/
    return reg.test(str)
  },
  // 是否是正数
  isInt: (str) => {
    const reg = /^\d+(\.\d{1,2})?$/
    return reg.test(str)
  },
  // 是否是正数
  isInt2: (str) => {
    if (str == 0) {
      return true
    } else {
      const reg = /^\d+(\.\d{1,2})?$/
      return reg.test(str)
    }
  },
  // 是否是正整数
  isPositiveInteger: (str) => {
    const reg = /(^[1-9]\d*$)/
    return reg.test(str)
  },
  // 是否是电话号码
  isPhone: (str) => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    return reg.test(str)
  }
}

//将通过fnum2转换的字符串转成数字 去掉逗号
function toNum(s) {
  let ns = s.toString().replace(/,/g, '')
  return Number(ns)
}

function fn2(n) {
  let l = n.split('.')
  if (l.length === 1) {
    n = n + '.00'
  } else if (l[1].length === 1) {
    n = n + '0'
  }
  return n
}

const fnum2 = (n) => {
  n = parseFloat(n)
  if (isNaN(n)) {
    return '0.00'
  } else {
    n = fn2(n.toString())
    return n.substring(0, n.indexOf('.') + 3).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&')
  }
}
// 处理url中的参数
function getQueryString(name, url) {
  var winObj = arguments.length > 1 ? arguments[1] : window;
  var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
  if (arguments.length <= 1) {
    if (typeof (winObj.location) != "object") {
      winObj = window;
    }
    if (reg.test(winObj.location.href)) return unescape(RegExp.$2.replace(/\+/g, " "));
    return "";
  } else {
    if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
    return "";
  }
}
// 校验手机号码
function isPhone(str) {
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
  return reg.test(str)
}
export {
  formatTime,
  numAdd,
  numSub,
  numMulti,
  numDiv,
  fnum2,
  toNum,
  _debounce,
  getQueryString,
  formatTimeFmt,
  isPhone,
}


// WEBPACK FOOTER //
// ./src/lib/js/until.js